// @flow
/**
 * Created by Mike Chung on 2/9/18.
 */

import {Country} from "../model/Country";
import type {LoadCountryActionCollection} from "../actions/app/countryAction";
import * as _ from "lodash";

export type CountryState = Array<Country>

const INITIAL_STATE: CountryState = [];

export default function reducer(state: CountryState = INITIAL_STATE, action: LoadCountryActionCollection): CountryState {

    switch (action.type) {
        case "app/LOAD_COUNTRY_SUCCESS_ACTION":
            let countries: Array<Country> = [].concat(action.countries);
            let hkCountry: Country = _.find(countries, (e: Country) => e.symbol === "HKG");
            let chinaCountry: Country = _.find(countries, (e: Country) => e.symbol === "CHN");
            let remainingCountry: Array<Country> = _.chain(countries).filter((e: Country) => e.symbol !== "HKG" && e.symbol !== "CHN").sortBy('name').value();
            return _.concat([hkCountry, chinaCountry], remainingCountry);
        case "app/LOAD_COUNTRY_FAILED_ACTION":
        default:
            return state;
    }

}


// WEBPACK FOOTER //
// ./src/reducers/CountryReducer.js